import { render, staticRenderFns } from "./SwapPoweredBy.vue?vue&type=template&id=950f4f06&scoped=true"
import script from "./SwapPoweredBy.vue?vue&type=script&lang=ts"
export * from "./SwapPoweredBy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950f4f06",
  null
  
)

export default component.exports